import { useEffect, useRef } from 'react';
import _ from 'lodash';

import usePropsCallback from './usePropsCallback';

const useDialog = (open, config) => {
  const openRef = useRef(!!open);
  const dataRef = useRef();

  if (typeof config === 'function') {
    config = config();
  }

  const onOpen = usePropsCallback(_.get(config, 'onOpen'));
  const onClose = usePropsCallback(_.get(config, 'onClose'));
  const onMount = usePropsCallback(_.get(config, 'onMount'));

  const isOpening = Boolean(open && !openRef.current);
  const isClosing = Boolean(!open && openRef.current);

  openRef.current = !!open;

  if (openRef.current) {
    const data = _.get(config, 'data');

    if (!_.isEqual(data, dataRef.current)) {
      dataRef.current = data;
    }
  }

  useEffect(() => {
    onMount();
  }, [onMount]);

  useEffect(() => {
    if (isOpening) {
      onOpen();
    } else if (isClosing) {
      onClose();
    }
  }, [onOpen, onClose, isOpening, isClosing]);

  return { isOpening, isClosing, data: dataRef.current };
};

export default useDialog;
